import { Theme, Typography } from '@mui/material';
import { FC } from 'react';
import { NavLink, useSearchParams } from 'react-router-dom';
import { makeStyles } from 'tss-react/mui';
import { useSnapshot } from 'valtio';
import EmptyPageAvatar from '../../common/components/EmptyPageAvatar';
import { AppPages } from '../../common/routing/app-navigator';
import ArtifactsStore from '../stores/artifacts-store';

const ArtifactsEmptyPage: FC = () => {
  const { classes } = useStyles();
  const { artifacts } = useSnapshot(ArtifactsStore);
  const [searchParams] = useSearchParams();
  const filters = searchParams.get('filters');

  if (artifacts.length > 0) {
    return null;
  }

  return (
    <EmptyPageAvatar
      text={
        <Typography component='div' className={classes.artifactsEmptyPage}>
          For artifact integrity please connect systems from the following list:
          <ul>
            <li>
              <NavLink to={`${AppPages.Connectors}?search=CI/CD`}>
                CI/CD
              </NavLink>
            </li>
            <li>
              <NavLink to={`${AppPages.Connectors}?search=Registry`}>
                Registry
              </NavLink>
            </li>
            <li>
              <NavLink to={`${AppPages.Connectors}?search=Cloud Deployment`}>
                Cloud
              </NavLink>
            </li>
          </ul>
          The more systems you connect, the better the information presented
          will be.
          {filters && (
            <>
              <br />
              Try removing some filters to show more results
            </>
          )}
        </Typography>
      }
    />
  );
};

const useStyles = makeStyles()((theme: Theme) => ({
  artifactsEmptyPage: {
    color: theme.palette.common.white,
    lineHeight: 1.2,
    '& ul': {
      marginBlock: theme.spacing(1),
      listStyle: 'inside',
    },
    '& li': {
      lineHeight: 1.5,
    },
    '& a': {
      color: 'inherit',
    },
  },
}));

export default ArtifactsEmptyPage;
